import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: null,
  error: null,
  loading: false,
};

export const addressValidation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.CLIENT_ADDRESS_VALIDATION_LOADING:
      return {
        data: null,
        error: null,
        loading: true,
      };

    case actionTypes.CLIENT_ADDRESS_VALIDATION_SUCCESS:
      return {
        data: action.payload,
        error: null,
        loading: false,
      };

    case actionTypes.CLIENT_ADDRESS_VALIDATION_ERROR:
      return {
        data: {},
        error: action.payload,
        loading: false,
      };

    case actionTypes.CLIENT_ADDRESS_VALIDATION_RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default addressValidation;
